import { runtimeEnv } from "./runtimeEnv";

export const getPublicApiBaseUrl = () =>
  runtimeEnv("API_BASE_URL") ||
  runtimeEnv("API_URL") ||
  "http://localhost:3001";

/**
 * REST API の URL から Socket.IO が待ち受ける origin を導出する。
 *
 * API は `/api` prefix 配下だが Socket.IO の handshake は origin 直下の
 * `/socket.io` を使用するため、API の pathname/query/fragment は引き継がない。
 */
export const deriveSocketBaseUrl = (apiBaseUrl: string): string => {
  const value = apiBaseUrl.trim();

  try {
    const url = new URL(value);
    if (!["http:", "https:"].includes(url.protocol)) {
      throw new TypeError("unsupported protocol");
    }
    return url.origin;
  } catch {
    // 古いローカル設定（schemeなし等）との互換性を残しつつ、少なくとも
    // REST専用の末尾 `/api` を Socket.IO namespace として渡さない。
    return value.replace(/\/+$/, "").replace(/\/api$/, "");
  }
};

export const getPublicSocketBaseUrl = () =>
  runtimeEnv("SOCKET_BASE_URL") ||
  deriveSocketBaseUrl(getPublicApiBaseUrl());
